import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import { SVGProps } from 'react'

// SVG

import NextIcon from '.././../icons/nextIcon.inline.svg'

import styles from './navigationArrows.module.scss'
// Color Constants
export enum ARROW_COLOR {
  WHITE = 'white',
  BLACK = 'black',
}

export interface NavigationArrowsProps {
  nextButtonDisabled?: boolean
  prevButtonDisabled?: boolean
  color?: ARROW_COLOR
  navOnRight?: boolean
  hideArrowOnMobile?: boolean
  className?: string
  onPrevClick: () => void
  onNextClick: () => void
  icon?: (() => JSX.Element) | React.FC<SVGProps<SVGElement>>
  prevClassName?: string
  nextClassName?: string
}

const NavigationArrows = ({
  nextButtonDisabled = false,
  prevButtonDisabled = false,
  hideArrowOnMobile = false,
  color = ARROW_COLOR.BLACK,
  className = '',
  icon,
  prevClassName,
  nextClassName,
  ...props
}: NavigationArrowsProps) => {
  const iconButtonClasses = classnames(styles.button, styles.icon, styles[`icon_color__${color}`])
  const { t } = useTranslation('common')
  const classNames = classnames(styles.navContainer, { [styles.hideOnMobile]: hideArrowOnMobile }, className)
  const Icon = icon ?? NextIcon

  return (
    <div className={classNames}>
      <button
        className={iconButtonClasses}
        onClick={props.onPrevClick}
        disabled={prevButtonDisabled}
        aria-label={t('previous')}
      >
        <Icon className={classnames(styles.prevIcon, styles.iconSize, prevClassName)} />
      </button>
      <button
        className={iconButtonClasses}
        onClick={props.onNextClick}
        disabled={nextButtonDisabled}
        aria-label={t('next')}
      >
        <Icon className={classnames(styles.iconSize, nextClassName)} />
      </button>
    </div>
  )
}

export default NavigationArrows
